import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import SectionWrapper from "~/components/layout/SectionWrapper";
import ContentContainer from "~/components/layout/ContentContainer";
import Row from "~/components/layout/Row";

import Expert from "~/components/Footer/Expert";
import WhereToBuy from "~/components/Footer/WhereToBuy";
import StayConnected from "~/components/Footer/StayConnected";

import { h2 } from "~/styles/typographyStyles";
import { setSmallSpacing } from "~/styles/helpers";

const Title = styled.h2`
    ${h2};
    color: ${({ theme }) => theme.palette.white};
    margin: ${({ theme }) => theme.layout.gutter} 0;
`;

const StyledColumn = styled.div`
    width: 100%;
    ${({ theme }) => setSmallSpacing(theme, "padding-left")};
    ${({ theme }) => setSmallSpacing(theme, "padding-right")};
    padding-top: ${({ theme }) => theme.layout.gutter};
    padding-bottom: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        width: 33%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}) {
        padding-top: ${({ theme }) => theme.layout.largeGutter};
    }
`;

const TopFooter = ({
    socialLinks = [],
    title = "",
    expertColumn = {},
    whereToBuyColumn = {},
    stayConnectedColumn = {},
    pageTitle = "",
}) => (
    <SectionWrapper
        noMarginBottom
        withPadding
        backgroundColor="darkBlue"
        sectionId="top-footer"
    >
        <ContentContainer>
            {title ? (
                <Row justifyContent="center" alignItems="center">
                    <Title>{title}</Title>
                </Row>
            ) : null}
            <Row>
                {expertColumn ? (
                    <StyledColumn sm={1 / 3}>
                        <Expert {...expertColumn} />
                    </StyledColumn>
                ) : null}

                {whereToBuyColumn ? (
                    <StyledColumn sm={1 / 3}>
                        <WhereToBuy {...whereToBuyColumn} />
                    </StyledColumn>
                ) : null}

                {stayConnectedColumn ? (
                    <StyledColumn sm={1 / 3}>
                        <StayConnected
                            {...stayConnectedColumn}
                            {...{ socialLinks, pageTitle }}
                        />
                    </StyledColumn>
                ) : null}
            </Row>
        </ContentContainer>
    </SectionWrapper>
);

TopFooter.propTypes = {
    socialLinks: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            linkUrl: PropTypes.string.isRequired,
        }),
    ),
    title: PropTypes.string,
    pageTitle: PropTypes.string.isRequired,
    expertColumn: PropTypes.shape({
        title: PropTypes.string,
        copy: PropTypes.string,
        buttonLabel: PropTypes.string,
        buttonUrl: PropTypes.string,
        callText: PropTypes.string,
    }),
    whereToBuyColumn: PropTypes.shape({
        title: PropTypes.string,
        copy: PropTypes.string,
        searchOptions: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
            }),
        ),
        searchPlaceholder: PropTypes.string,
        shopText: PropTypes.string,
    }),
    stayConnectedColumn: PropTypes.shape({
        title: PropTypes.string,
        copy: PropTypes.string,
        emailInputPlaceholder: PropTypes.string,
        emailInputId: PropTypes.string,
        privacyInputId: PropTypes.string,
        pageTitleInputId: PropTypes.string,
        pageUrlInputId: PropTypes.string,
        agreementOptions: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
            }),
        ),
    }),
};

export default TopFooter;
